import React from "react"
import Home from "@/components/home"

export default function EN () {
  return <Home lang="en" />
}
